/* EcoFlow Malaysia — the official-memorandum pop-up.
 *
 * Opens on its own once per visitor per EDITION, from any link marked
 * data-efm-open, or from ?memo=<slug> so a memo can be sent as a URL.
 *
 * Once per EDITION, not once per visit and not once a day: a notice of
 * record is read once and then it is in the way. The edition stamp is in the
 * markup (data-efm-edition), so re-issuing a memo shows it again to people
 * who already dismissed the last one, and a typo fix does not.
 *
 * Deliberately not here: any fetch. Both memos are already in the page, so
 * the pop-up opens with no network at all, and the PDFs are plain anchors —
 * middle-click and "save link as" work on them like any other link.
 */
(function () {
  "use strict";

  var doc = document;
  var root = doc.getElementById("ef-memo");
  if (!root || typeof root.showModal !== "function") return;

  var tabs = [].slice.call(root.querySelectorAll("[data-efm-tab]"));
  var panes = [].slice.call(root.querySelectorAll("[data-efm-pane]"));
  var pdfs = [].slice.call(root.querySelectorAll("[data-efm-pdf]"));
  var body = root.querySelector("[data-efm-body]");
  var edition = root.getAttribute("data-efm-edition") || "0";
  var KEY = "ef-memo-seen";

  var store = {
    get: function () { try { return window.localStorage.getItem(KEY); } catch (e) { return null; } },
    set: function (v) { try { window.localStorage.setItem(KEY, v); } catch (e) {} }
  };

  function select(slug) {
    var hit = false;
    tabs.forEach(function (t) {
      var on = t.getAttribute("data-efm-tab") === slug;
      hit = hit || on;
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.tabIndex = on ? 0 : -1;
    });
    if (!hit) return false;
    panes.forEach(function (p) { p.hidden = p.getAttribute("data-efm-pane") !== slug; });
    /* The download belongs to the memo on screen, not to the dialog. */
    pdfs.forEach(function (a) { a.hidden = a.getAttribute("data-efm-pdf") !== slug; });
    if (body) body.scrollTop = 0;
    return true;
  }

  function open(slug) {
    if (slug) select(slug);
    if (!root.open) root.showModal();
  }

  /* Tabs behave like tabs: click, and Left/Right/Home/End across the set. */
  tabs.forEach(function (t, i) {
    t.addEventListener("click", function () { select(t.getAttribute("data-efm-tab")); });
    t.addEventListener("keydown", function (e) {
      var n = { ArrowLeft: i - 1, ArrowRight: i + 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (n === undefined) return;
      e.preventDefault();
      var next = tabs[(n + tabs.length) % tabs.length];
      select(next.getAttribute("data-efm-tab"));
      next.focus();
    });
  });

  /* A click on the backdrop lands on the <dialog> itself, never on the card. */
  root.addEventListener("click", function (e) {
    if (e.target === root || (e.target.closest && e.target.closest("[data-efm-close]"))) root.close();
  });
  root.addEventListener("close", function () { store.set(edition); });

  doc.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest("[data-efm-open]");
    if (!a) return;
    e.preventDefault();
    open(a.getAttribute("data-efm-open") || "");
  });

  /* ?memo=<slug> opens that memo; ?memo=1 opens the first. Sharing the link
     has to work whether or not the visitor has dismissed the pop-up before,
     so this path ignores the stamp. */
  var m = /[?&]memo=([^&#]*)/.exec(location.search);
  if (m) {
    var want = decodeURIComponent(m[1]);
    open(want && want !== "1" ? want : "");
    return;
  }

  /* On the landing page the memo shows EVERY time (owner, 19OCT2026): it is
     the notice the store wants a first-time visitor to read, and most of them
     arrive there. Anywhere else it is once per edition, so it does not follow
     someone around the site. `routes.root_url` is on the element, so /ms/
     counts as the landing page too. */
  var home = root.getAttribute("data-efm-home") || "/";
  var here = location.pathname.replace(/\/+$/, "") || "/";
  var landing = here === (home.replace(/\/+$/, "") || "/");

  if (!landing && store.get() === edition) return;

  /* The homepage and /pages/home-energy already open the OCEAN 2 early-bird
     pop-up at 2.5s. Two showModal() calls stack one dialog on top of another,
     so this one queues behind whatever is already open and takes its turn
     when that closes. If the visitor never closes the other one, this does
     not interrupt them — the edition stamp is unset, so the memo comes up on
     their next page instead. */
  function other() {
    var all = doc.querySelectorAll("dialog[open]");
    for (var i = 0; i < all.length; i++) if (all[i] !== root) return all[i];
    return null;
  }

  /* Late enough that it does not fight the page for the first paint, and a
     beat behind the early-bird pop-up so `other()` sees it. */
  setTimeout(function queue() {
    if (root.open) return;
    var o = other();
    if (!o) { open(""); return; }
    o.addEventListener("close", function () { setTimeout(queue, 700); }, { once: true });
  }, 3400);
})();
